import { useSession } from "@outschool/ui-auth";
import { useExperiment } from "@outschool/ui-experiments";
import { useIsMobile } from "@outschool/ui-utils";
import { useEffect, useMemo } from "react";
import { useHasCompletedOnboardingQuiz } from "../useHasCompletedOnboardingQuiz";
import { useHasLoggedIn } from "../useHasLoggedIn";

const EXPERIMENT_NAME = "MobileCDPExpGroup1Rd3";
export function useMobileCDPGroupExperiment(): boolean {
  const isMobile = useIsMobile();
  const { currentUserHasLoaded, isLoggedIn } = useSession();
  const hasCompletedQuiz = useHasCompletedOnboardingQuiz();
  const hasLoggedIn = useHasLoggedIn();
  const { variant, trigger } = useExperiment({
    currentUserHasLoaded,
    experimentName: EXPERIMENT_NAME,
  });

  let pathname = "";
  if (typeof window !== "undefined") {
    pathname = window.location.pathname;
  }
  const classDetailPathPattern = /^\/classes\/[\w-]+$/;
  const isClassDetailPagePath = classDetailPathPattern.test(pathname);
  const shouldTrigger =
    isMobile &&
    isClassDetailPagePath &&
    !isLoggedIn &&
    !hasCompletedQuiz &&
    !hasLoggedIn;

  useEffect(() => {
    if (!shouldTrigger) {
      return;
    }
    trigger();
  }, [shouldTrigger, trigger]);

  return useMemo(() => {
    if (!shouldTrigger) {
      return false;
    }
    return variant === "treatment";
  }, [shouldTrigger, variant]);
}
